module.exports = __webpack_public_path__ + "static/media/warning_purple.96f3fe5c.svg";